import { getClientIp } from '@/utils/ip-proxy-utils';

export default defineNuxtPlugin(async (nuxtApp) => {
  const baseUrl = useRuntimeConfig().public.apiUrl;
  const i18n = nuxtApp.$i18n;
  const locales: string[] = i18n.locales.value.map((locale: any) => locale.code);

  const { data } = await useAsyncData(`translations`, async () => {
    const promises: Promise<any>[] = [];

    for (const locale of locales) {
      promises.push(
        $fetch(`${baseUrl}/translations`, {
          onRequest: ({ options }) => {
            const requestHeaders = useRequestHeaders();
            for (const [key, value] of Object.entries(requestHeaders)) {
              options.headers.set(key, value);
            }

            if (import.meta.server) {
              const event = useRequestEvent();
              const { clientIp, xff } = getClientIp(event, 'api');
              if (xff) options.headers.set('x-forwarded-for', xff);
              if (clientIp) options.headers.set('x-real-ip', clientIp);
              if (clientIp) options.headers.set('x-client-ip', clientIp);
            }

            options.headers.set('accept', 'application/json');
            options.headers.set('accept-language', locale);
          },
          onResponseError: (ctx) => {
            throw createError({
              statusCode: ctx.response.status,
              statusMessage: ctx.response.statusText,
              fatal: true
            });
          }
        })
      );
    }

    return await Promise.all(promises);
  });

  for (let i = 0; i < locales.length; i += 1) {
    i18n.setLocaleMessage(locales[i], data.value[i]);
  }
});
